import {deletePromotionImage} from '../../../service/promotions/promotions-api';
import {useUploadPromotionImage} from '../../../service/promotions/promotions-hook';
import {PromotionFormFieldsEnum, PromotionFormType} from '../../../service/promotions/promotions-type';
import {Form} from '../../../typings/antd';
import {noop} from '../../../util/function';
import {PublicationMediaStep} from '../../publication-wizard/publication-media-step';
import {Text} from '../../text/text';

// Yandex help for promotions: JPG/PNG, single image, minimum 900 × 480 px.
const PROMOTION_MEDIA_MIN_WIDTH = 900;
const PROMOTION_MEDIA_MIN_HEIGHT = 480;
const PROMOTION_MEDIA_MAX_WIDTH = 5000;
const PROMOTION_MEDIA_MAX_HEIGHT = 5000;

type PropsType = {
    onPreviousStep: VoidFunction;
    onStepFinished: VoidFunction;
    onStepActivated: (width: number) => void;
    width: number;
};

const banner = (
    <>
        <Text block bolder stringKey="PROMOTIONS__FORM__IMAGES" />
        <Text block stringKey="PROMOTIONS__FORM__UPLOAD_IMAGES__SINGLE" />
        <Text block stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_2" />
        <Text
            block
            stringKey="PROMOTIONS__FORM__UPLOAD_IMAGES__RESOLUTION"
            valueMap={{
                minHeight: PROMOTION_MEDIA_MIN_HEIGHT,
                minWidth: PROMOTION_MEDIA_MIN_WIDTH,
            }}
        />
    </>
);

// Single image for promotions.
export function PromotionMediaStep(props: PropsType): JSX.Element {
    const {onPreviousStep, onStepFinished, onStepActivated, width} = props;

    const {mutateAsync: uploadImage} = useUploadPromotionImage();

    return (
        <Form.Item<PromotionFormType> name={PromotionFormFieldsEnum.Images} noStyle>
            <PublicationMediaStep
                banner={banner}
                maxCount={1}
                maxHeight={PROMOTION_MEDIA_MAX_HEIGHT}
                maxWidth={PROMOTION_MEDIA_MAX_WIDTH}
                minHeight={PROMOTION_MEDIA_MIN_HEIGHT}
                minWidth={PROMOTION_MEDIA_MIN_WIDTH}
                onPreviousStep={onPreviousStep}
                onStepActivated={onStepActivated}
                onStepFinished={onStepFinished}
                remove={(imageId) => deletePromotionImage(imageId).catch(noop)}
                upload={(file) => uploadImage(file)}
                uploaderTextLangKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__UPLOADER_TEXT"
                width={width}
            />
        </Form.Item>
    );
}
